import React from 'react';
import { connect } from 'react-redux';
import * as actTableManagement from 'actions/tableManagement';
import ConfirmActionModal from 'components/ConfirmActionModal';
import {
  ContentWrapper,
  LeftColumnWrapper,
  RightColumnWrapper,
  PageWrapper,
} from 'components/wrappers/pages';
import { formValueSelector } from 'redux-form';
import NoDataAndLoading from 'components/NoDataAndLoading';
import './TableManagementReport.css';
import { getFormattedTime } from 'utils/hourFilter';
import * as clevertapTableManagement from 'clevertap/tableManagement';
import ReportDetail from './ReportDetail';
import List from './List';
import ActionBar from './ActionBar';

class TableManagementReport extends React.Component {
  componentDidMount() {
    this.props.dispatch(actTableManagement.reportPageRequest());
  }

  render() {
    const { tableManagementReport, loadingSpinner } = this.props.data;
    const { openRightColumn, reports } = tableManagementReport;
    const { showLoadingSpinnerPage } = loadingSpinner;
    return (
      <PageWrapper>
        <ActionBar
          location={this.props.location}
          onChangeOutlet={this._onChangeOutlet}
          onChangeDate={this._onChangeDate}
          onChangeStatus={this._onChangeStatus}
          onExport={this._onClickExport}
        />
        <ContentWrapper>
          <LeftColumnWrapper openRightColumn={openRightColumn}>
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={reports.length === 0}
              title="No data to display"
              description=""
            />
            {!showLoadingSpinnerPage && <List />}
          </LeftColumnWrapper>
          <RightColumnWrapper openRightColumn={openRightColumn}>
            <ReportDetail />
          </RightColumnWrapper>
        </ContentWrapper>
        <ConfirmActionModal />
      </PageWrapper>
    );
  }

  _onChangeStatus = statusIds => {
    const {
      startDate,
      endDate,
      startHour,
      endHour,
      allDay,
    } = this.props.search.date;
    const { outletIds } = this.props.search;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    this.props.dispatch(
      actTableManagement.changeReportStatus({
        outletIds,
        startDate: formattedStart,
        endDate: formattedEnd,
        statusIds,
      })
    );
  };

  _onChangeOutlet = (outletIds = []) => {
    const {
      startDate,
      endDate,
      startHour,
      endHour,
      allDay,
    } = this.props.search.date;
    const { statusIds } = this.props.search;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    this.props.dispatch(
      actTableManagement.onReportsChangeOutletIds({
        outletIds,
        startDate: formattedStart,
        endDate: formattedEnd,
        statusIds,
      })
    );
  };

  _onChangeDate = ({ startDate, endDate, startHour, endHour, allDay }) => {
    const { statusIds } = this.props.search;
    const { outletIds } = this.props.search;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    this.props.dispatch(
      actTableManagement.changeReportDate({
        outletIds,
        startDate: formattedStart,
        endDate: formattedEnd,
        statusIds,
      })
    );
  };

  _onClickExport = () => {
    const { startDate, endDate } = this.props.search.date;
    const { outletIds } = this.props.search;
    clevertapTableManagement.tableReportExport({
      outletIds,
      startDate,
      endDate,
    });
  };
}

const selector = formValueSelector('search');

function mapStateToProps(state) {
  return {
    search: {
      outletIds: selector(state, 'outletIds'),
      date: selector(state, 'date'),
      statusIds: selector(state, 'statusIds'),
    },
    data: {
      tableManagementGroup: state.tableManagement.group,
      tableManagementReport: state.tableManagement.report,
      loadingSpinner: state.loadingSpinner,
    },
    nextAction: state.confirmAction.nextAction,
  };
}

export default connect(mapStateToProps)(TableManagementReport);
